import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import * as React from "react";
import { useContext } from "react";
import DataContext from "../../../../ContextServer/DataContext";
import { Button, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import { FcCollaboration } from "react-icons/fc";
import { unstable_HistoryRouter, useNavigate } from "react-router-dom";

function TableListPopUp({ open, handleClose }) {
  const {
    AdminReplyOnSubmit,
    adminReply1,
    adminReply2,
    adminReply3,
    setAdminReply1,
    setAdminReply2,
    setAdminReply3,

    adminReportsDetail,
  } = useContext(DataContext);
  const navigate = useNavigate();
  const history = unstable_HistoryRouter;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: window.innerWidth < 600 ? "100vh" : 800,
    backgroundColor: "white",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "2px solid #ffc55e",
    boxShadow: 24,
    p: 4,
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
          setAdminReply1("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box>
            <div className="AdminPopUpHead">
              <h3>
                <FcCollaboration style={{ fontSize: 20 }} /> 신고 상세내역*
              </h3>
              <p>
                <small>신고일시 : {adminReportsDetail[0]?.datetime}</small>
              </p>
            </div>
            {/* 
            <div
              style={{ width: "100%", height: "4vh", textAlign: "right" }}
            ></div> */}

            <br />
            <div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <label>
                    <small>작성자</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReportsDetail[0]?.report_nm}
                    autoComplete="given-name"
                    size={"small"}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>
                    <small>번호</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReportsDetail[0]?.report_mob_num}
                    autoComplete="given-name"
                    size={"small"}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <label>
                    <small>주소</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReportsDetail[0]?.report_addr}
                    autoComplete="given-name"
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <label>
                    <small>악취강도</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReportsDetail[0]?.stink_levelnm}
                    autoComplete="given-name"
                    sx={{ backgroundColor: "orange" }}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <label>
                    <small>악취종류</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReportsDetail[0]?.stink_div}
                    autoComplete="given-name"
                    sx={{ backgroundColor: "orange" }}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <label>
                    <small>추가 요청내용</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReportsDetail[0]?.bigo}
                    autoComplete="given-name"
                    multiline
                    rows={3}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <label>
                    <small>조치결과*</small>
                  </label>

                  <TextField
                    required
                    fullWidth
                    value={adminReply1}
                    onChange={(e) => setAdminReply1(e.target.value)}
                    helperText="조치결과에 대한 답변을 달아주세요."
                    placeholder={adminReportsDetail[0]?.report_reply1}
                    autoComplete="given-name"
                    multiline
                    rows={7}
                  />
                  <label>
                    <small>조치결과 2</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReply2}
                    onChange={(e) => setAdminReply2(e.target.value)}
                    helperText="조치결과에 대한 추가답변을 달아주세요."
                    placeholder={adminReportsDetail[0]?.report_reply2}
                    autoComplete="given-name"
                    multiline
                    rows={7}
                  />
                  <label>
                    <small>조치결과 3</small>
                  </label>
                  <TextField
                    required
                    fullWidth
                    value={adminReply3}
                    onChange={(e) => setAdminReply3(e.target.value)}
                    helperText="조치결과에 대한 추가답변을 달아주세요."
                    placeholder={adminReportsDetail[0]?.report_reply3}
                    autoComplete="given-name"
                    multiline
                    rows={7}
                  />
                </Grid>
              </Grid>

              <div style={{ textAlign: "center", marginTop: "1vh" }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    alert("등록 완료 되었습니다.");
                    AdminReplyOnSubmit();
                    navigate("/odor/declarelist/admin");
                    handleClose();
                    window.location.reload();
                  }}
                >
                  답변등록
                </Button>

                <Button
                  variant="outlined"
                  sx={{ marginLeft: 1 }}
                  color={"secondary"}
                  onClick={() => {
                    handleClose();
                    setAdminReply1("");
                    setAdminReply2("");
                    setAdminReply3("");
                  }}
                >
                  답변취소
                </Button>
              </div>
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default TableListPopUp;
